import DoneIcon from "@mui/icons-material/Done";
import BlockIcon from "@mui/icons-material/Block";

import CustomButton from "../../helper-components/input/CustomButton";

import { defaultButton, defaultId, defaultStyle, defaultTime, noEditStyle } from "./shared.js";

// Custom functions for table columns.
const renderFound = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((r) => r.id === params.row.transcript_id);

    const text = transcript?.text ?? "";
    const quote = params.row.text;

    if (text.includes(quote)) {
        return <CustomButton icon={<DoneIcon className="cursor-default" />} tooltip={"Found in transcript"} />;
    }

    return <CustomButton icon={<BlockIcon className="cursor-default" />} tooltip={"Not found in latest transcript"} />;
};

const clickButton = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((r) => r.id === params.row.transcript_id);

    const cmd = transcript?.status === "PROCESSED" ? "view" : "edit";
    props.browser.navigate(`/database/transcripts/${params.row.transcript_id}/${cmd}`);
};

const createTitle = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((r) => r.id === params.row.transcript_id);

    return transcript?.status === "PROCESSED" ? "View" : "Edit";
};

const disableButton = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((r) => r.id === params.row.transcript_id);
    return !transcript || transcript.status === "AWAITING_PROCESSING";
};

// Column definitions.
const resource = (props) => ({
    ...defaultStyle,
    field: "resource.name",
    headerName: "Resource",
    flex: 0.2,
    minWidth: 175,
    valueGetter: (params) => {
        const resource = props?.backend?.resources?.data?.find((r) => r.id === params.row.resource_id);
        return resource?.name ?? "N/A";
    }
});
const text = { ...defaultStyle, field: "text", headerName: "Quote", flex: 0.25, minWidth: 200 };
const found = (props) => {
    return {
        ...defaultStyle,
        ...noEditStyle,
        flex: 0.1,
        field: "transcript_id",
        headerName: "Status",
        minWidth: 65,
        renderCell: (params) => renderFound(props, params)
    };
};
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, disabled: disableButton, title: createTitle }), minWidth: 100, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [defaultId, resource(props), text, found(props), createdOn, updatedOn, action(props)];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
